export default {
    or: 'albo',
    privacy: {
        url: 'https://rountine.com/polityka-prywatnosci/',
        link: 'Polityka prywatności',
        pageLink: 'Polityka prywatności — rountine.com',
    },
    fields: {
        email: 'Email',
        emailPlaceholder: 'ty{\'@\'}example.com',
        password: 'Hasło',
        repeatPassword: 'Powtórz hasło',
    },
    password: {
        show: 'Pokaż hasło',
        hide: 'Ukryj hasło',
        tooShort: 'Hasło musi mieć co najmniej 8 znaków.',
        mismatch: 'Hasła nie są takie same.',
        minPlaceholder: 'min. 8 znaków',
    },
    google: {
        unverifiedEmail: 'To konto Google nie ma potwierdzonego adresu e-mail.',
        failed: 'Logowanie przez Google nie powiodło się. Spróbuj ponownie albo zaloguj się hasłem.',
    },
    login: {
        subtitle: 'Zaloguj się, aby kontynuować',
        resetDone: 'Hasło zostało zmienione. Zaloguj się nowym hasłem.',
        accountDeleted: 'Konto i wszystkie dane zostały usunięte.',
        invalid: 'Nieprawidłowy email lub hasło.',
        failed: 'Logowanie nie powiodło się. Spróbuj ponownie.',
        forgot: 'Nie pamiętasz hasła?',
        submit: 'Zaloguj się',
        submitting: 'Loguję…',
        noAccount: 'Nie masz konta?',
    },
    register: {
        subtitle: 'Załóż nowe konto',
        emailTaken: 'Ten email jest już zajęty.',
        failed: 'Rejestracja nie powiodła się. Spróbuj ponownie.',
        submit: 'Zarejestruj się',
        submitting: 'Zakładam konto…',
        acceptPolicy: 'Zakładając konto, akceptujesz {policy}.',
        policyLink: 'politykę prywatności',
        haveAccount: 'Masz już konto?',
    },
    reset: {
        subtitleRequest: 'Zresetuj hasło',
        subtitleConfirm: 'Wpisz kod i nowe hasło',
        requestIntro: 'Podaj adres e-mail konta. Jeśli istnieje, wyślemy na niego 6-cyfrowy kod.',
        send: 'Wyślij kod',
        sending: 'Wysyłam…',
        sendFailed: 'Nie udało się wysłać kodu. Spróbuj ponownie.',
        tooManyIn: 'Wysłano już kilka kodów na ten adres. Kolejny możesz wysłać za {minutes} min — sprawdź też folder spam.',
        tooManyLater: 'Wysłano już kilka kodów na ten adres. Kolejny możesz wysłać za jakiś czas — sprawdź też folder spam.',
        codeSent: 'Wysłaliśmy kod na {email}.',
        code: 'Kod z e-maila',
        codeInvalid: 'Kod musi składać się z 6 cyfr.',
        codeWrong: 'Nieprawidłowy lub wygasły kod.',
        newPassword: 'Nowe hasło',
        change: 'Zmień hasło',
        changing: 'Zmieniam…',
        changeFailed: 'Nie udało się zmienić hasła. Spróbuj ponownie.',
        noCode: 'Nie masz kodu?',
        resend: 'Wyślij ponownie',
        remember: 'Pamiętasz hasło?',
    },
};
